import { useCallback, useEffect, useState, useMemo, useRef } from "react";
import { useSeriesStore } from "../../../stores/seriesStore";
import { useProjectStore } from "../../../stores/projectStore";
import { useStructuredOutlineStore } from "../StructuredOutline/StructuredOutlineStore";
import Auth from "../../../Auth";
import { FUNCTION_NAMES } from "..";
import { useStoryBibleStore } from "src/stores/storyBibleStore";
import MenuSelect from "src/sudokit/components/SudoSelect/MenuSelect";

export default function SeriesSelectorButton({ type, handleSeriesChange }) {
  const project = useProjectStore((state) => state.project);
  const [selectedOption, setSelectedOption] = useState(null);
  const contents = useSeriesStore((state) => state.contents);
  const getContentsBySeriesId = useSeriesStore((state) => state.getContentsBySeriesId);
  const setOutline = useStructuredOutlineStore((state) => state.setOutline);
  const selectedSeriesProjectId = useSeriesStore((state) => state.selectedSeriesProjectId);
  const setSelectedProject = useSeriesStore((state) => state.setSelectedProject);
  const setSelectedSeriesProjectId = useSeriesStore((state) => state.setSelectedSeriesProjectId);
  const setIsActive = useStoryBibleStore((state) => state.setIsActive);
  const currentSeriesTitle = useSeriesStore((state) => state.currentSeriesTitle);
  const seriesSelectorRef = useRef(null);

  const loadSelectionMap = useMemo(() => {
    return {
      [FUNCTION_NAMES.OUTLINE]: async (option) => {
        const { outline } = await Auth.fetchWithIdToken(`/api/outline`, {
          projectId: option.projectId,
        });
        setOutline(outline);
      },
    };
  }, [setOutline]);

  const handleOnSelect = useCallback(
    (option) => {
      setSelectedSeriesProjectId(option.projectId);
      setSelectedOption(option);
      setSelectedProject(type, option);
      setIsActive(true);

      if (handleSeriesChange) {
        handleSeriesChange(option.projectId);
      }

      const loader = loadSelectionMap[type];
      if (loader) {
        loader(option);
      } else {
        console.error(`No loader found for type: ${type}`);
      }
    },
    [type, setSelectedProject, loadSelectionMap, handleSeriesChange, setSelectedSeriesProjectId]
  );

  useEffect(() => {
    getContentsBySeriesId(project.seriesId);
  }, [project.seriesId]);

  useEffect(() => {
    if (contents?.length > 0) {
      const currentProject = contents.find((c) => (selectedSeriesProjectId ? c.projectId === selectedSeriesProjectId : c.projectId === project.id));
      setSelectedOption(currentProject);
      setSelectedProject(type, currentProject);
      if (!selectedSeriesProjectId) {
        setSelectedSeriesProjectId(currentProject?.projectId);
      }
    }
  }, [contents, project.id, selectedSeriesProjectId, setSelectedProject, type, setSelectedSeriesProjectId]);

  return (
    <MenuSelect
      ref={seriesSelectorRef}
      options={contents.map((project) => ({ value: project.projectId, label: project.title }))}
      value={selectedOption?.projectId ?? ""}
      onChange={(option) => {
        const selectedProject = contents.find((c) => c.projectId === option);
        handleOnSelect(selectedProject);
      }}
      placeholder="Select book"
      label={`Select a book from the ${currentSeriesTitle} series`}
      variant="tertiary"
      collisionBoundarySelector=".sudokit-modal"
    />
  );
}
